exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{max-width:none}.clickable{color:#90caf9;text-decoration:none}.clickable:hover{cursor:pointer;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/style/global.css
// module id = 288
// module chunks = 0